import React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

export interface CupomStatusBadgeProps {
  status: 'ATIVO' | 'INATIVO' | string;
}

const COLORS: Record<string, { label: string; color: string; bg: string }> = {
  ATIVO: { label: 'Ativo', color: '#28a745', bg: 'rgba(40,167,69,0.2)' },
  INATIVO: { label: 'Inativo', color: '#6c757d', bg: 'rgba(108,117,125,0.2)' },
};

const CupomStatusBadge: React.FC<CupomStatusBadgeProps> = ({ status }) => {
  const cfg = COLORS[status] || { label: status, color: '#6c757d', bg: 'rgba(108,117,125,0.2)' };
  return (
    <Chip
      label={cfg.label}
      className="ps-2"
      sx={{
        backgroundColor: cfg.bg,
        color: cfg.color,
        fontWeight: 500,
        '& .MuiChip-icon': { marginLeft: 0, marginRight: 0.5 },
      }}
      icon={<Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: cfg.color }} />}
      size="small"
    />
  );
};

export default CupomStatusBadge;
